<template>
  <span class="tail-describe">
    <span>
      <i class="sp icontishishuoming" style="font-size:12px;"></i>
    </span>
    <div class="notice-content" :style="customWidth ? {width: customWidth} : ''">
      <slot></slot>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    noticeContent: {
      type: String,
      default: ""
    },
    customWidth: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang='scss'>
.tail-describe {
  cursor: pointer;
  display: inline-block;
  position: relative;
  margin-left: 5px;
  span {
    // color: #808693;
    font-size: 12px;
    display: inline-block;
  }
  .notice-content{
    position: absolute;
    bottom: 100%;
    left: 100%;
    padding: 6px;
    background: #F8F8F8;
    font-size: 12px;
    border-radius: 4px;
    line-height: 16px;
    display: none;
    color: #808693;
  }
  &:hover .notice-content{
    display: block;
  }
}
</style>
